import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=df810ede&scoped=true&"
import script from "./menu.vue?vue&type=script&lang=ts&"
export * from "./menu.vue?vue&type=script&lang=ts&"
import style0 from "./menu.vue?vue&type=style&index=0&id=df810ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df810ede",
  null
  
)

export default component.exports